export const prices = [
        {
            "roof_type": 1,
            "walkable": 7,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4200.0000,
            "high_price": 8000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 7,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5600.0000,
            "high_price": 10400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 7,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8400.0000,
            "high_price": 13600.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 7,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10500.0000,
            "high_price": 16800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 8,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4550.0000,
            "high_price": 8400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 8,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5950.0000,
            "high_price": 10800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 8,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 14000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 8,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10850.0000,
            "high_price": 17200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 9,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6300.0000,
            "high_price": 8800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 9,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8100.0000,
            "high_price": 11200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 9,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11700.0000,
            "high_price": 14400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 9,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 14400.0000,
            "high_price": 19200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 7,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4200.0000,
            "high_price": 8000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 7,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5600.0000,
            "high_price": 10400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 7,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8400.0000,
            "high_price": 13600.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 7,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10500.0000,
            "high_price": 16800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 8,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4550.0000,
            "high_price": 8400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 8,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5950.0000,
            "high_price": 10800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 8,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 14000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 8,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10850.0000,
            "high_price": 17200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 9,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6300.0000,
            "high_price": 8800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 9,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8100.0000,
            "high_price": 11200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 9,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11700.0000,
            "high_price": 14400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 9,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 14400.0000,
            "high_price": 19200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 7,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4200.0000,
            "high_price": 8000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 7,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5600.0000,
            "high_price": 10400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 7,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8400.0000,
            "high_price": 13600.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 7,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10500.0000,
            "high_price": 16800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 8,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4550.0000,
            "high_price": 8400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 8,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5950.0000,
            "high_price": 10800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 8,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 14000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 8,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10850.0000,
            "high_price": 17200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 9,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6300.0000,
            "high_price": 8800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 9,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8100.0000,
            "high_price": 11200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 9,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 9100.0000,
            "high_price": 14400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 9,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 14400.0000,
            "high_price": 19200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 7,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4200.0000,
            "high_price": 8000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 7,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5600.0000,
            "high_price": 10400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 7,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8400.0000,
            "high_price": 13600.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 7,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10500.0000,
            "high_price": 16800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 8,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4550.0000,
            "high_price": 8400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 8,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5950.0000,
            "high_price": 10800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 8,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 14000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 8,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10850.0000,
            "high_price": 17200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 9,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6300.0000,
            "high_price": 8800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 9,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8100.0000,
            "high_price": 11200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 9,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11700.0000,
            "high_price": 14400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 9,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 14400.0000,
            "high_price": 19200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 7,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4200.0000,
            "high_price": 8000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 7,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5600.0000,
            "high_price": 10400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 7,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8400.0000,
            "high_price": 13600.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 7,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10500.0000,
            "high_price": 16800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 8,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4550.0000,
            "high_price": 8400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 8,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5950.0000,
            "high_price": 10800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 8,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 14000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 8,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10850.0000,
            "high_price": 17200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 9,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6300.0000,
            "high_price": 8800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 9,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8100.0000,
            "high_price": 11200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 9,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11700.0000,
            "high_price": 14400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 9,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 14400.0000,
            "high_price": 19200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 7,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4200.0000,
            "high_price": 8000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 7,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5600.0000,
            "high_price": 10400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 7,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8400.0000,
            "high_price": 13600.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 7,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 13500.0000,
            "high_price": 16800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 8,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4550.0000,
            "high_price": 8400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 8,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5950.0000,
            "high_price": 10800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 8,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 14000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 8,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10850.0000,
            "high_price": 17200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 9,
            "home_size": 10,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6300.0000,
            "high_price": 8800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 9,
            "home_size": 11,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8100.0000,
            "high_price": 11200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 9,
            "home_size": 12,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11700.0000,
            "high_price": 14400.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 9,
            "home_size": 13,
            "stories": 0,
            "window_type": 0,
            "window_size": 0,
            "low_price": 14400.0000,
            "high_price": 19200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 10,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4500.0000,
            "high_price": 9000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 11,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6000.0000,
            "high_price": 12000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 12,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7500.0000,
            "high_price": 15000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 13,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10500.0000,
            "high_price": 21000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 10,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5250.0000,
            "high_price": 10500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 11,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6750.0000,
            "high_price": 13500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 12,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8250.0000,
            "high_price": 16500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 13,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11250.0000,
            "high_price": 22500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 10,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5750.0000,
            "high_price": 11500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 11,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7250.0000,
            "high_price": 14500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 12,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 17500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 1,
            "walkable": 0,
            "home_size": 13,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11750.0000,
            "high_price": 23500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 10,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4500.0000,
            "high_price": 9000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 11,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6000.0000,
            "high_price": 12000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 12,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7500.0000,
            "high_price": 15000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 13,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10500.0000,
            "high_price": 21000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 10,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5250.0000,
            "high_price": 10500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 11,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6750.0000,
            "high_price": 13500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 12,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8250.0000,
            "high_price": 16500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 13,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11250.0000,
            "high_price": 22500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 10,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5750.0000,
            "high_price": 11500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 11,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7250.0000,
            "high_price": 14500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 12,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 17500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 2,
            "walkable": 0,
            "home_size": 13,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11750.0000,
            "high_price": 23500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 10,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4250.0000,
            "high_price": 8500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 11,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5750.0000,
            "high_price": 11500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 12,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7250.0000,
            "high_price": 14500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 13,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10250.0000,
            "high_price": 20500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 10,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5000.0000,
            "high_price": 10000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 11,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6500.0000,
            "high_price": 13000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 12,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8000.0000,
            "high_price": 16000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 13,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11000.0000,
            "high_price": 22000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 10,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5500.0000,
            "high_price": 11000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 11,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7000.0000,
            "high_price": 14000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 12,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8500.0000,
            "high_price": 17000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 3,
            "walkable": 0,
            "home_size": 13,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11500.0000,
            "high_price": 23000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 10,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4350.0000,
            "high_price": 8700.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 11,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5850.0000,
            "high_price": 11700.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 12,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7350.0000,
            "high_price": 14700.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 13,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10350.0000,
            "high_price": 20700.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 10,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5100.0000,
            "high_price": 10200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 11,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6600.0000,
            "high_price": 13200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 12,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8100.0000,
            "high_price": 16200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 13,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11100.0000,
            "high_price": 22200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 10,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5600.0000,
            "high_price": 11200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 11,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7100.0000,
            "high_price": 14200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 12,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8600.0000,
            "high_price": 17200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 4,
            "walkable": 0,
            "home_size": 13,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11600.0000,
            "high_price": 23200.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 10,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4500.0000,
            "high_price": 9000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 11,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6000.0000,
            "high_price": 12000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 12,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7500.0000,
            "high_price": 15000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 13,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10500.0000,
            "high_price": 21000.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 10,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5250.0000,
            "high_price": 10500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 11,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6750.0000,
            "high_price": 13500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 12,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8250.0000,
            "high_price": 16500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 13,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11250.0000,
            "high_price": 22500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 10,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5750.0000,
            "high_price": 11500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 11,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7250.0000,
            "high_price": 14500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 12,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8750.0000,
            "high_price": 17500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 5,
            "walkable": 0,
            "home_size": 13,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11750.0000,
            "high_price": 23500.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 10,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4150.0000,
            "high_price": 8300.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 11,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5650.0000,
            "high_price": 11300.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 12,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7150.0000,
            "high_price": 14300.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 13,
            "stories": 14,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10150.0000,
            "high_price": 20300.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 10,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 4900.0000,
            "high_price": 9800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 11,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6400.0000,
            "high_price": 12800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 12,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 7900.0000,
            "high_price": 15800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 13,
            "stories": 15,
            "window_type": 0,
            "window_size": 0,
            "low_price": 10900.0000,
            "high_price": 21800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 10,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 5400.0000,
            "high_price": 10800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 11,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 6900.0000,
            "high_price": 13800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 12,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 8400.0000,
            "high_price": 16800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 6,
            "walkable": 0,
            "home_size": 13,
            "stories": 16,
            "window_type": 0,
            "window_size": 0,
            "low_price": 11400.0000,
            "high_price": 22800.0000,
            "vinyl_low_price": 0.00,
            "vinyl_high_price": 0.00,
            "premium_low_price": 0.00,
            "premium_high_price": 0.00,
            "fiberglass_low_price": 0.00,
            "fiberglass_high_price": 0.00
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 18,
            "window_size": 28,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 530.0000,
            "vinyl_high_price": 825.0000,
            "premium_low_price": 650.0000,
            "premium_high_price": 1020.0000,
            "fiberglass_low_price": 715.0000,
            "fiberglass_high_price": 1346.4000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 18,
            "window_size": 31,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 600.0000,
            "vinyl_high_price": 990.0000,
            "premium_low_price": 800.0000,
            "premium_high_price": 1320.0000,
            "fiberglass_low_price": 880.0000,
            "fiberglass_high_price": 1742.4000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 18,
            "window_size": 34,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 750.0000,
            "vinyl_high_price": 1210.0000,
            "premium_low_price": 950.0000,
            "premium_high_price": 1560.0000,
            "fiberglass_low_price": 1045.0000,
            "fiberglass_high_price": 2059.2000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 19,
            "window_size": 28,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 530.0000,
            "vinyl_high_price": 825.0000,
            "premium_low_price": 650.0000,
            "premium_high_price": 1020.0000,
            "fiberglass_low_price": 715.0000,
            "fiberglass_high_price": 1346.4000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 19,
            "window_size": 31,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 600.0000,
            "vinyl_high_price": 990.0000,
            "premium_low_price": 800.0000,
            "premium_high_price": 1320.0000,
            "fiberglass_low_price": 880.0000,
            "fiberglass_high_price": 1742.4000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 19,
            "window_size": 34,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 750.0000,
            "vinyl_high_price": 1210.0000,
            "premium_low_price": 950.0000,
            "premium_high_price": 1560.0000,
            "fiberglass_low_price": 1045.0000,
            "fiberglass_high_price": 2059.2000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 20,
            "window_size": 28,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 680.0000,
            "vinyl_high_price": 1045.0000,
            "premium_low_price": 748.0000,
            "premium_high_price": 1379.4000,
            "fiberglass_low_price": 1000.0000,
            "fiberglass_high_price": 1680.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 20,
            "window_size": 31,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 840.0000,
            "vinyl_high_price": 1320.0000,
            "premium_low_price": 924.0000,
            "premium_high_price": 1742.4000,
            "fiberglass_low_price": 1200.0000,
            "fiberglass_high_price": 1800.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 20,
            "window_size": 34,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 1000.0000,
            "vinyl_high_price": 1540.0000,
            "premium_low_price": 1100.0000,
            "premium_high_price": 2032.8000,
            "fiberglass_low_price": 1500.0000,
            "fiberglass_high_price": 2160.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 21,
            "window_size": 28,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 680.0000,
            "vinyl_high_price": 1045.0000,
            "premium_low_price": 748.0000,
            "premium_high_price": 1379.4000,
            "fiberglass_low_price": 1000.0000,
            "fiberglass_high_price": 1680.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 21,
            "window_size": 31,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 840.0000,
            "vinyl_high_price": 1320.0000,
            "premium_low_price": 924.0000,
            "premium_high_price": 1742.4000,
            "fiberglass_low_price": 1200.0000,
            "fiberglass_high_price": 1800.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 21,
            "window_size": 34,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 1000.0000,
            "vinyl_high_price": 1540.0000,
            "premium_low_price": 1100.0000,
            "premium_high_price": 2032.8000,
            "fiberglass_low_price": 1500.0000,
            "fiberglass_high_price": 2160.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 22,
            "window_size": 29,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 1100.0000,
            "vinyl_high_price": 1760.0000,
            "premium_low_price": 1300.0000,
            "premium_high_price": 2040.0000,
            "fiberglass_low_price": 1300.0000,
            "fiberglass_high_price": 2280.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 22,
            "window_size": 32,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 1400.0000,
            "vinyl_high_price": 2145.0000,
            "premium_low_price": 1500.0000,
            "premium_high_price": 2520.0000,
            "fiberglass_low_price": 1500.0000,
            "fiberglass_high_price": 2640.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 22,
            "window_size": 35,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 1900.0000,
            "vinyl_high_price": 2750.0000,
            "premium_low_price": 2100.0000,
            "premium_high_price": 3240.0000,
            "fiberglass_low_price": 2100.0000,
            "fiberglass_high_price": 3360.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 23,
            "window_size": 30,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 1500.0000,
            "vinyl_high_price": 2310.0000,
            "premium_low_price": 1670.0000,
            "premium_high_price": 2640.0000,
            "fiberglass_low_price": 1837.0000,
            "fiberglass_high_price": 3484.8000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 23,
            "window_size": 33,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 1800.0000,
            "vinyl_high_price": 2722.5000,
            "premium_low_price": 1970.0000,
            "premium_high_price": 3120.0000,
            "fiberglass_low_price": 2167.0000,
            "fiberglass_high_price": 4118.4000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 23,
            "window_size": 36,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 2200.0000,
            "vinyl_high_price": 3333.0000,
            "premium_low_price": 2425.0000,
            "premium_high_price": 3870.0000,
            "fiberglass_low_price": 2667.0000,
            "fiberglass_high_price": 4260.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 24,
            "window_size": 28,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 530.0000,
            "vinyl_high_price": 825.0000,
            "premium_low_price": 650.0000,
            "premium_high_price": 1020.0000,
            "fiberglass_low_price": 715.0000,
            "fiberglass_high_price": 1346.4000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 24,
            "window_size": 31,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 600.0000,
            "vinyl_high_price": 990.0000,
            "premium_low_price": 800.0000,
            "premium_high_price": 1320.0000,
            "fiberglass_low_price": 880.0000,
            "fiberglass_high_price": 1742.4000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 24,
            "window_size": 34,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 750.0000,
            "vinyl_high_price": 1210.0000,
            "premium_low_price": 950.0000,
            "premium_high_price": 1560.0000,
            "fiberglass_low_price": 1045.0000,
            "fiberglass_high_price": 2059.2000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 25,
            "window_size": 31,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 3300.0000,
            "vinyl_high_price": 6600.0000,
            "premium_low_price": 4000.0000,
            "premium_high_price": 9600.0000,
            "fiberglass_low_price": 4500.0000,
            "fiberglass_high_price": 10800.0000
        },
        {
            "roof_type": 0,
            "walkable": 0,
            "home_size": 0,
            "stories": 0,
            "window_type": 26,
            "window_size": 31,
            "low_price": 0.00,
            "high_price": 0.00,
            "vinyl_low_price": 4100.0000,
            "vinyl_high_price": 7480.0000,
            "premium_low_price": 4800.0000,
            "premium_high_price": 10560.0000,
            "fiberglass_low_price": 5300.0000,
            "fiberglass_high_price": 11760.0000
        }
    ]


    export const estimateMultiplier =  [
        {
            "id": 1,
            "multiplier": 1.0,
            "multiplier_text": "Asphalt (Architectural)"
        },
        {
            "id": 2,
            "multiplier": 1.75,
            "multiplier_text": "Designed Asphalt"
        },
        {
            "id": 3,
            "multiplier": 3.0,
            "multiplier_text": "Metal"
        },
        {
            "id": 4,
            "multiplier": 3.0,
            "multiplier_text": "Composite or Wood Shake"
        },
        {
            "id": 5,
            "multiplier": 1.0,
            "multiplier_text": "Vinyl Siding"
        },
        {
            "id": 6,
            "multiplier": 2.0,
            "multiplier_text": "LP Siding"
        },
        {
            "id": 7,
            "multiplier": 2.5,
            "multiplier_text": "Cedar Siding"
        }
    ]

    export const estimateDetail =  {
        "1": "Cross Hipped",
        "2": "Dormer",
        "3": "Hip",
        "4": "Hip and Valley",
        "5": "Intersecting/Overlaid Hip",
        "6": "Open Gable",
        "7": "Walkable",
        "8": "Slightly Walkable",
        "9": "Too Steep to Walk",
        "10": "0-1000 sq ft",
        "11": "1000-1750 sq ft",
        "12": "1750-2500 sq ft",
        "13": "2500+",
        "14": "1 story",
        "15": "2 stories",
        "16": "3 stories",
        "17": "4 stories",
        "18": "Double Hung",
        "19": "Slider",
        "20": "Casement",
        "21": "Awning",
        "22": "Twin Casement",
        "23": "Triple Casement",
        "24": "Picture",
        "25": "3 Lite Bay/Bow",
        "26": "4 Lite Bay/Bow",
        "28": "Small (under 70 ui)",
        "29": "Small (under 100 ui)",
        "30": "Small (under 125 ui)",
        "31": "Medium (70-90 ui)",
        "32": "Medium (100-120 ui)",
        "33": "Medium (125-150 ui)",
        "34": "Large (90+ ui)",
        "35": "Large (120+ ui)",
        "36": "Large (150+ ui)"
    }